export default __webpack_public_path__ + "static/media/FaChevronDown.7649bf04.svg";